import React from "react";
import {
  Box, Stack, Typography, TextField,
  Radio, RadioGroup, FormControlLabel,
  Select, MenuItem,
} from "@mui/material";
import { NTH_OPTIONS, WEEK_DAYS } from "../../../constants/recurrenceConstants";

const MonthlyPicker = ({ values, set, setMany }) => {
  const isFixed = values.monthlyMode === "fixed";

  return (
    <Box>
      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#475569", mb: 1.5 }}>
        Repeat on
      </Typography>

      <RadioGroup
        value={values.monthlyMode}
        onChange={(e) => set("monthlyMode", e.target.value)}
      >
        {/* Option 1: Fixed day of month */}
        <FormControlLabel
          value="fixed"
          control={<Radio size="small" sx={{ color: "#0D9488", "&.Mui-checked": { color: "#0D9488" } }} />}
          label={
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography sx={{ fontSize: "13px", color: "#475569", fontWeight: 500 }}>
                Day
              </Typography>
              <TextField
                type="number"
                size="small"
                disabled={!isFixed}
                value={values.recurrenceDayOfMonth}
                onChange={(e) =>
                  set("recurrenceDayOfMonth", Math.min(31, Math.max(1, parseInt(e.target.value) || 1)))
                }
                inputProps={{ min: 1, max: 31 }}
                sx={{ width: 70 }}
              />
              <Typography sx={{ fontSize: "13px", color: "#475569", fontWeight: 500 }}>
                of the month
              </Typography>
            </Stack>
          }
        />

        {/* Option 2: Nth weekday */}
        <FormControlLabel
          value="nth"
          control={<Radio size="small" sx={{ color: "#0D9488", "&.Mui-checked": { color: "#0D9488" } }} />}
          label={
            <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
              <Typography sx={{ fontSize: "13px", color: "#475569", fontWeight: 500 }}>
                The
              </Typography>
              <Select
                size="small"
                disabled={isFixed}
                value={values.recurrenceNthWeekday?.n ?? 1}
                onChange={(e) =>
                  setMany({ recurrenceNthWeekday: { ...values.recurrenceNthWeekday, n: e.target.value } })
                }
                sx={{ minWidth: 90, fontSize: "13px" }}
              >
                {NTH_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value} sx={{ fontSize: "13px" }}>
                    {o.label}
                  </MenuItem>
                ))}
              </Select>
              <Select
                size="small"
                disabled={isFixed}
                value={values.recurrenceNthWeekday?.d ?? 1}
                onChange={(e) =>
                  setMany({ recurrenceNthWeekday: { ...values.recurrenceNthWeekday, d: e.target.value } })
                }
                sx={{ minWidth: 110, fontSize: "13px" }}
              >
                {WEEK_DAYS.map((d) => (
                  <MenuItem key={d.value} value={d.value} sx={{ fontSize: "13px" }}>
                    {d.full}
                  </MenuItem>
                ))}
              </Select>
              <Typography sx={{ fontSize: "13px", color: "#475569", fontWeight: 500 }}>
                of the month
              </Typography>
            </Stack>
          }
        />
      </RadioGroup>
    </Box>
  );
};

export default MonthlyPicker;
